<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>{{ localOfferId && 'edit' || 'add' }}</mat-icon>
      {{ localOfferId && 'Edit' || 'Add' }} {{ listingId ? "" : "Local" }} Offer
    </h1>
  </section>
  <section mat-dialog-content>
    <mat-form-field>
      <mat-label>Company Name</mat-label>
      <input formControlName="company_name" matInput required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Offer</mat-label>
      <input formControlName="offer" matInput required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Offer Description</mat-label>
      <textarea formControlName="description" matInput></textarea>
    </mat-form-field>
    <mat-form-field>
      <input placeholder="Expiry date" matInput [matDatepicker]="expiryDate" formControlName="expiry_date">
      <mat-datepicker-toggle matSuffix [for]="expiryDate"></mat-datepicker-toggle>
      <mat-datepicker #expiryDate></mat-datepicker>
    </mat-form-field>
    <section class="thumbnails">
      <button type="button" mat-button (click)="addNewImage()">
        Select Image
      </button>
      @if (this.image) {
        <section>
          <img alt="image-thumbnail" [src]="getImageSrc(this.image)" />
          <button (click)="clearImage()" mat-icon-button>
            <mat-icon>cancel</mat-icon>
          </button>
        </section>
      }
    </section>
    <mat-form-field>
      <mat-label>How to redeem</mat-label>
      <input formControlName="redemption_instructions" matInput />
      <mat-hint>E.g. show discount card</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Terms & Conditions</mat-label>
      <textarea formControlName="t_cs" matInput></textarea>
    </mat-form-field>
    @for (location of locations().controls; track location; let i = $index) {
      <div
        formArrayName="locations"
        >
        <div [formGroupName]="i" class="locations">
          <div>
            <mat-form-field>
              <input formControlName="location_id" matInput />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Location Title</mat-label>
              <input formControlName="location_title" matInput required />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Latitude</mat-label>
              <input formControlName="lat" matInput />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Longitude</mat-label>
              <input formControlName="lng" matInput />
            </mat-form-field>
          </div>
          @if (i !== 0) {
            <button
              type="button"
              mat-icon-button
              (click)="remove(i, location)"
              >
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </div>
    }

    <button type="button" mat-button (click)="addLocationFields()">
      <mat-icon>add</mat-icon>
      Add Location
    </button>
  </section>

  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
      >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      [disabled]="!form.valid || loading"
      mat-button
      matTooltip="Save product info."
      type="submit"
      >
      <mat-icon>save</mat-icon>
      Save
    </button>
  </section>
</form>
